import { useState, useEffect } from 'react';
import classNames from 'classnames';
import Text from '../../Atoms/Text';

type StepProps = {
  steps: string[];
  theme?: 'dark' | 'light';
  timerDuration?: number;
  className?: string;
};

function StepsList({
  steps,
  timerDuration = 3,
  className,
  theme = 'dark'
}: StepProps) {
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setActiveStep(
        (prevActiveStep) =>
          (prevActiveStep + 1) % steps.length
      );
    }, timerDuration * 1000);

    return () => clearInterval(intervalId);
  }, [steps.length, timerDuration]);

  return (
    <div className={className}>
      {steps.map((step) => (
        <div
          key={steps.indexOf(step)}
          className={classNames([
            'relative flex flex-row items-center gap-7 py-5 before:absolute before:top-1/2 before:left-[10px] before:h-full before:w-[3px]  last:before:hidden lg:gap-5',
            theme === 'light' && 'before:bg-white',
            theme === 'dark' && 'before:bg-sl-blue',

            steps.indexOf(step) === activeStep
              ? theme === 'light' && 'text-sl-yellow'
              : theme === 'light' &&
                'text-white before:bg-white',
            steps.indexOf(step) === activeStep
              ? theme === 'dark' && 'text-sl-indigo'
              : theme === 'dark' &&
                'text-sl-blue before:bg-sl-blue'
          ])}
        >
          <div
            className={classNames([
              'relative z-10 h-6 w-6 min-w-[24px] rounded-full border-[3px] duration-300',
              steps.indexOf(step) === activeStep
                ? theme === 'light' &&
                  'border-sl-yellow bg-sl-yellow'
                : theme === 'light' &&
                  'border-white bg-sl-indigo',
              steps.indexOf(step) === activeStep
                ? theme === 'dark' &&
                  'border-sl-indigo bg-sl-indigo'
                : theme === 'dark' &&
                  'border-sl-blue bg-white'
            ])}
          />
          <Text
            color="inherit"
            size="sm"
            font="circular"
            weight={400}
          >
            {step}
          </Text>
        </div>
      ))}
    </div>
  );
}

export default StepsList;
